export const dealsBoardQueryKeys = {
  all: ['deals-board'] as const,
  board: () => [...dealsBoardQueryKeys.all, 'board'] as const,
}
